/* eslint no-unused-vars: 0 */

/**
 * This file was automatically generated by ruby_to_typescript.rake.
 * Do not modify it by hand.
 */
export enum RequestUseCase {
  NOVEL_TECHNOLOGY = "NOVEL_TECHNOLOGY",
  PROCESS_PRODUCT_IMPROVEMENTS = "PROCESS_PRODUCT_IMPROVEMENTS",
  TESTING_ANALYSIS = "TESTING_ANALYSIS",
  EXPERTS = "EXPERTS",
  PROGRAM_PARTICIPANTS = "PROGRAM_PARTICIPANTS",
}
